// src/components/dashboard/TidesCard.js
import React from "react";
import { Typography } from "@mui/material";
import TideChart from "../weather/tidegraph.js";
import StyledPaper from "./StyledPaper";

const TidesCard = ({ divesite }) => {
  return (
    <StyledPaper>
      <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
        {divesite.uddf.divesite.site.name}
      </Typography>
      <TideChart
        station={divesite.metadata.additionalInfo.closestTideStation}
        compact
      />
    </StyledPaper>
  );
};

export default TidesCard;
